export default {
  name: 'Input',
  props: {
    type: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
  },
  computed: {
    hasLabel() {
      return !!this.$slots.default;
    },
  },
};
